import { AdditionalMenu } from 'common/components/AdditionalMenu';
import MenuItem, { MenuItemProps } from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText, { ListItemTextProps } from '@mui/material/ListItemText';
import { isEmpty } from 'lodash';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
export type ActionDef<T> =
  | {
      enabled?: boolean | ((data: T) => boolean);
      icon?: React.ReactNode;
      label: string;
      slotProps?: {
        menuItem?: MenuItemProps;
        menuItemText?: ListItemTextProps;
      };
      actionCallback?: (data: T) => void;
    }
  | {
      type: 'separtor';
    };

export type ActionCellProps<T> = {
  data: T;
  actions: ActionDef<T>[];
};

export const ActionCell = <T,>({ actions, data }: ActionCellProps<T>) => {
  const enabledActions = actions.filter((action: any) => {
    let result;
    if (typeof action.enabled === 'function') {
      result = action.enabled(data);
    } else {
      result = action.enabled;
    }
    // != -> used here becuase only for false value we want false for others ex. undefiend need true
    // eslint-disable-next-line eqeqeq
    return result != false;
  });

  const notSeparatorAction = enabledActions.filter((action: any) => action.type !== 'separtor');

  return isEmpty(notSeparatorAction) ? null : (
    <AdditionalMenu>
      {({ onClose }) => (
        <>
          {enabledActions.map((action: any, index) => {
            if (action.type === 'separtor') {
              return (
                <Box
                  key={action.label}
                  sx={{
                    height: 12,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <Divider />
                </Box>
              );
            }

            const menuTextItemProps = action.slotProps?.menuItemText ?? {};
            const menuItemProps = action.slotProps?.menuItem ?? {};
            return (
              <MenuItem
                key={action.id || index}
                {...menuItemProps}
                onClick={() => {
                  if (action.actionCallback) {
                    action.actionCallback(data);
                  }

                  if (action.closable ?? true) {
                    onClose();
                  }
                }}
              >
                {action.icon ? <ListItemIcon>{action.icon}</ListItemIcon> : null}
                <ListItemText {...menuTextItemProps}>{action.label}</ListItemText>
              </MenuItem>
            );
          })}
        </>
      )}
    </AdditionalMenu>
  );
};
